module.exports = {"id":"215449","name":"Robert Skov","rating":"71","photo":"./data/images/photos/0/215449.png","club":{"name":"FC Copenhague","logo":"./data/images/clubs/FCCopenhague.png"},"positions":["MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RobertSkov0.json
// module id = 3634
// module chunks = 0